// Shared client-side attachment validation for the chat composer and the booking pop-ups.
// Limits come from the server (injected in messages/index.html.twig); fallbacks guard a missing
// injection. The server re-checks on submit.

export function fileExtension(name) {
    return name.includes('.') ? name.split('.').pop() : '';
}

export function attachmentLimits() {
    return {
        maxBytes: window.attachmentMaxBytes || 100 * 1024 * 1024,
        maxFiles: window.attachmentMaxFiles || 10,
        allowedExtensions: window.attachmentAllowedExtensions
            || ['png', 'jpg', 'jpeg', 'gif', 'svg', 'pdf', 'doc', 'docx', 'txt', 'mp4'],
    };
}

// Returns a translation key for the first validation failure, or null when the file is valid.
export function attachmentError(file, {maxBytes, allowedExtensions}) {
    if (file.size > maxBytes) {
        return 'messages.Attachment too large';
    }

    if (!allowedExtensions.includes(fileExtension(file.name).toLowerCase())) {
        return 'validators.file_attachment_format_is_not_allowed';
    }

    return null;
}
